'use client';

import Hotjar from '@hotjar/browser';
import { useEffect, Suspense } from 'react';

import { publicEnv } from '~/definitions/publicEnv';

const HOTJAR_VERSION = 6;

const HotjarComponent = () => {
  useEffect(() => {
    const initHotjar = () => {
      try {
        const hotJarId = publicEnv.CORE_PLANNER_HOTJAR_SITE_ID ? Number(publicEnv.CORE_PLANNER_HOTJAR_SITE_ID) : 0;

        Hotjar.init(hotJarId, HOTJAR_VERSION);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Failed to initialize Hotjar:', error);
      } finally {
        if (process.env.NODE_ENV === 'development') {
          // eslint-disable-next-line no-console
          console.log('Hotjar initiated');
        }
      }

      window.removeEventListener('click', initHotjar);
      window.removeEventListener('scroll', initHotjar);
    };

    window.addEventListener('click', initHotjar);
    window.addEventListener('scroll', initHotjar);

    return () => {
      window.removeEventListener('click', initHotjar);
      window.removeEventListener('scroll', initHotjar);
    };
  }, []);

  return null;
};

export const HotjarAnalytics = () =>
  publicEnv.CORE_PLANNER_HOTJAR_SITE_ID && publicEnv.APP_ENV === 'production' ? (
    <Suspense>
      <HotjarComponent />
    </Suspense>
  ) : null;
